import React, { Component } from 'react'
import styled, { withTheme } from 'styled-components'
import { Helmet } from 'react-helmet'
import Isvg from 'react-inlinesvg'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import Parser from 'html-react-parser'
import { updatePhoneId } from '../App/actions'
import { createEvent } from '../UserEvents/actions'

const NotFoundBanner =  styled.div.attrs(() => ({
  className: 'animated fadeIn'
}))`
  padding: 15px;
  margin: 0 auto;
  text-align: center;

  svg {
    max-width: 350px;
  }

  h1 {
    margin-top: 0px;
    color: var(--clr-accent-to-grey-0);
    text-transform: uppercase;
    font-weight: 600;
  }

  color: var(--clr-grey-3-to-text);

  a {
    color: var(--clr-accent-to-grey-0);
  }

  .cls-7 {
    stroke: var(--clr-accent-to-grey-0);
  }

  .cls-1 {
    fill: var(--clr-grey-3-to-text);
  }

  .cls-6,
  .cls-8 {
    stroke: var(--clr-grey-3-to-text);
  }
`

class NotFound extends Component {
  componentDidMount() {
    this.props.updatePhoneId(null)
    if (this.props.location.state) {
      this.props.createUserEvent({
        category: '404s',
        data: {
          id: Math.uuid(),
          page_url: this.props.location.state.origin,
          originating_link: this.props.location.state.referrer,
        }
      })
    }
  }

  render() {
    const { query, language, theme } = this.props
    let translated = messages[language]
    let notFoundOverride = theme.getOption('lookupError')

    return (
      <NotFoundBanner>
        <Helmet title={translated['404err']} />
        <Isvg src="/img/404.svg">{translated['404err']}</Isvg>
        <Choose>
          <When condition={notFoundOverride}>{Parser(notFoundOverride)}</When>
          <Otherwise>
            <h1>{translated['404title']}</h1>
            <p>{translated['404desc']}</p>
            <Link to={{ pathname: '/', query: query }}>
              {translated['homeLink']}
            </Link>
          </Otherwise>
        </Choose>
      </NotFoundBanner>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  query: state.routing.locationBeforeTransitions.query,
  location: ownProps.location
})

const mapDispatchToProps = dispatch => ({
  updatePhoneId: phoneId => dispatch(updatePhoneId(phoneId)),
  createUserEvent: event => dispatch(createEvent(event)),
})

export default LanguageProvider(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(NotFound)
  )
)



// WEBPACK FOOTER //
// ./src/containers/Error/NotFound.js